/**
 * Capitalizes the first character of a string.
 *
 * @param {[string]} str - The input string to capitalize
 * @returns {string | undefined} The input string with its first character capitalized, or undefined if input is undefined
 *
 * @example
 * capitalize('hello') // returns 'Hello'
 * capitalize('multi-word example') // returns 'Multi-word example'
 * capitalize('') // returns '' (empty string)
 * capitalize(undefined) // returns undefined
 */
export function capitalize(str?: string): string | undefined {
    if (str === undefined || typeof str !== 'string') {
        return undefined;
    }

    if (str === '') {
        return '';
    }

    // Capitalize the first character and concatenate with the rest of the string
    return str.charAt(0).toUpperCase() + str.slice(1);
}
